import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../utils/getTestLabels.js';
import style from './Skeleton.module.scss.js';

const { componentTestLabel } = getTestLabels('Skeleton');
const defaultDimension = '1.25rem';
/**
 * [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Skeleton/Skeleton.tsx)
 *
 * @param {string} height - (optional) A CSS height value.
 * @param {string} shape - (optional) Can be 'circle' or 'square'. When provided, the `width` prop will be used for both height and width.
 * @param {string} width - (optional) A CSS width value. Defaults to `1.25rem`.
 */
const Skeleton = forwardRef((props, ref) => {
    const { className, height = defaultDimension, shape, width, ...otherProps } = props;
    const fixedWidth = shape ? width || defaultDimension : width;
    const fixedHeight = shape ? width : height;
    return (jsx("div", { style: { width: fixedWidth, height: fixedHeight }, "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames(style['z-skeleton'], {
            [style[`z-skeleton--circle`]]: shape === 'circle',
        }, className) }));
});
Skeleton.displayName = 'Skeleton';

export { Skeleton };
//# sourceMappingURL=Skeleton.js.map
